export default __webpack_public_path__ + "static/193-42660be2a919acccccc9ec3d4327880d.jpg";